if (!customElements.get('bottle-product-sticky')) {
  customElements.define(
    'bottle-product-sticky',
    class BottleProductSticky extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.getElementById(this.dataset.mainButtonId);
        this.mainPrice = document.getElementById(`price-${this.dataset.sectionId}`);
        this.stickyButton = this.querySelector('.bottle-product-sticky__button');
        this.stickyPrice = this.querySelector('.bottle-product-sticky__price');

        if (!this.mainButton || !this.stickyButton) return;

        this.handleStickyClick = () => {
          if (!this.mainButton.disabled && this.mainButton.getAttribute('aria-disabled') !== 'true') {
            this.mainButton.click();
          }
        };
        this.stickyButton.addEventListener('click', this.handleStickyClick);

        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
        });

        if (this.mainPrice && this.stickyPrice) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.mainPrice, { childList: true, subtree: true });
        }

        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            const mainButtonHasBeenPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.hidden = !mainButtonHasBeenPassed;
          },
          { threshold: 0 }
        );
        this.visibilityObserver.observe(this.mainButton);

        this.syncButton();
        this.syncPrice();
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleStickyClick);
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }

      syncButton() {
        const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        const mainLabel = this.mainButton.querySelector('span')?.textContent.trim();

        this.stickyButton.disabled = disabled;
        if (mainLabel) this.stickyButton.textContent = mainLabel;
      }

      syncPrice() {
        if (this.mainPrice && this.stickyPrice) {
          this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
        }
      }
    }
  );
}
